"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendNeutral = function TrendNeutral() {
  return _react2.default.createElement(
    "g",
    { id: "trend-neutral" },
    _react2.default.createElement("path", {
      d: "M75.3475672,249.924014 C70.6657328,234.869658 56.6126723,223.93792 40.003951,223.93792 C19.5672332,223.93792 3,240.489487 3,260.90688 C3,281.324272 19.5672332,297.87584 40.003951,297.87584 C55.3737458,297.87584 68.5549378,288.514177 74.1462369,275.187036 L425.265301,273.672245 C430.468067,287.799343 444.058149,297.87584 460.003951,297.87584 C480.440669,297.87584 497.007902,281.324272 497.007902,260.90688 C497.007902,240.489487 480.440669,223.93792 460.003951,223.93792 C444.180885,223.93792 430.677414,233.859894 425.386927,247.816026 L75.3475672,249.924014 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = TrendNeutral;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TrendNeutral.js
// module id = 3003
// module chunks = 4